module.exports = __webpack_public_path__ + "img/Weapon_202.57cb1345.png";